import { FcGoogle } from "react-icons/fc";
import { Button } from "@web/components/ui/button";
import { Config } from "@web/config/env";

// TODO : ui 패키지에서 구현, props로 전달받도록 변경
export function GoogleLoginButton() {
  const handleLogin = () => {
    const redirect = encodeURIComponent(window.location.origin);
    window.location.href = `${Config.API_URL}/api/v1/auth/google?redirect=${redirect}`;
  };

  return (
    <Button onClick={handleLogin}>
      <FcGoogle />
      Google Login
    </Button>
  );
}

